import React from 'react';
import { Body } from '@highlight-ui/typography';

import { SelectOption, SelectOptionLabelProps } from '../../../types';
import { searchSubstring } from '../../../helpers';

const SingleLineOptionLabel = <T extends SelectOption>({
  highlightedText,
  option: { label: text },
  selected = false,
  disabled = false,
}: SelectOptionLabelProps<T>) => {
  const startIndex = searchSubstring(text, highlightedText);
  const endIndex = startIndex + highlightedText.length;

  return (
    <Body
      color={disabled ? 'text-disabled' : 'text-default'}
      variant={selected ? 'strong-base' : 'base'}
    >
      {startIndex === -1 ? (
        text
      ) : (
        <>
          {text.substring(0, startIndex)}
          <b>{text.substring(startIndex, endIndex)}</b>
          {text.substring(endIndex)}
        </>
      )}
    </Body>
  );
};

export default SingleLineOptionLabel;
